import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import HomeDashboard from "@/pages/HomeDashboard";
import WorkTracker from "@/pages/WorkTracker";
import ProjectDashboard from "@/pages/ProjectDashboard";
import InternalOps from "@/pages/InternalOps";
import ClientRetainerLog from "@/pages/ClientRetainerLog";
import InvoiceTracking from "@/pages/InvoiceTracking";
import Placeholder from "@/pages/Placeholder";

function Protected() {
  const { user, booting } = useAuth();
  if (booting) {
    return <div className="min-h-screen flex items-center justify-center text-sm text-gray-400">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout><Outlet /></Layout>;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected />}>
            <Route index element={<HomeDashboard />} />
            <Route path="/work-tracker" element={<WorkTracker />} />
            <Route path="/projects" element={<ProjectDashboard />} />
            <Route path="/clients" element={<ClientRetainerLog />} />
            <Route path="/internal-ops" element={<InternalOps />} />
            <Route path="/invoices" element={<InvoiceTracking />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
